/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.data-block__item[_ngcontent-%COMP%]{align-items:center}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.SingleNonEnterpriseElement[_ngcontent-%COMP%]{width:144%!important}}"];
export { styles as styles };
